/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ rank: NonNullable<unknown> }} Meta_Run_Opponent_FinishedInputs */



/**
* | output |
* | --- |
* | "finished {rank}" |
*
* @param {Meta_Run_Opponent_FinishedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const meta_run_opponent_finished = /** @type {((inputs: Meta_Run_Opponent_FinishedInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Run_Opponent_FinishedInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`beendet als ${i?.rank}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`a terminé ${i?.rank}`)
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ (`最终 ${i?.rank}`)
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ (`最終 ${i?.rank}`)
	if (locale === "ko") return /** @type {LocalizedString} */ (`최종 ${i?.rank}`)
	return /** @type {LocalizedString} */ (`finished ${i?.rank}`)
});